function leftMenu(){

  const leftMenu = $('.left-menu');

  // Toggle mobile account menu
  leftMenu.find('.list-item-toggle').click(() => {
    leftMenu.find('.list-item').toggleClass('open').stop().slideToggle('fast', () => {
      if ( leftMenu.find('.list-item').is(':hidden') ) {
        leftMenu.find('.list-item').removeAttr('style');
      }
    });
  });

}

$( leftMenu );
